import { render, staticRenderFns } from "./ProblemTaskList.vue?vue&type=template&id=4a933750"
import script from "./ProblemTaskList.vue?vue&type=script&lang=js"
export * from "./ProblemTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports